import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export const PropTypeNumber = ({
  label,
  value,
  onChange,
  propKey,
  disabled,
  errors,
  unit,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(String(value));
  }, [value]);

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function handleBlur() {
    const sanitizedValue = String(inputValue).replace(',', '.');
    const newValue = parseFloat(sanitizedValue);

    if (!isNaN(newValue)) {
      onChange(newValue, propKey);
    } else {
      onChange("", propKey);
    }
  }

  return (
    <TextField
      label={label}
      type="text"
      variant="filled"
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      disabled={disabled}
      error={Boolean(errors[propKey])}
      helperText={errors[propKey]}
      InputProps={{
        endAdornment: <InputAdornment position="end">{unit}</InputAdornment>,
      }}
    />
  );
};